import { Box, Button, Grid, ListItem, ListItemIcon, ListItemText, Popover, useTheme, withStyles, } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import React, { Fragment } from 'react';
import clsx from 'clsx';
import omit from 'lodash/omit';
const styles = (theme) => ({
    avatarButton: {
        color: 'inherit',
        borderRadius: '100px',
        padding: '7px 8px',
        minWidth: 0,
        marginRight: theme.spacing(-1.5),
    },
    avatarNameHeader: {
        paddingLeft: theme.spacing(2),
    },
    popoverWrapper: {
        '& > .MuiPaper-root': {
            paddingBottom: theme.spacing(1),
            marginTop: theme.spacing(1),
        },
        '& > * > *': {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    },
    popupOpen: {
        background: 'rgba(0, 0, 0, 0.08)',
    },
    header: {
        paddingTop: theme.spacing(2.5),
        paddingBottom: theme.spacing(2.5),
        marginBottom: theme.spacing(1),
        background: '#F8FAFB',
    },
    email: {
        color: theme.palette.text.secondary,
        fontSize: 13,
    },
    name: {
        lineHeight: '1.1em',
    },
    listItemIconRoot: {
        minWidth: theme.spacing(4),
        fontSize: 18,
        display: 'flex',
        justifyContent: 'center',
        marginRight: 16,
        color: '#778CA2',
    },
    listItemTextPrimary: {
        textTransform: 'uppercase',
        fontSize: 12,
    },
    menuLink: {
        color: 'inherit',
        display: 'block',
        textDecoration: 'none',
        padding: 0,
    },
});
function NavbarProfileButton(props) {
    const { classes, avatar, firstLine, secondLine, listItems } = props;
    const theme = useTheme();
    const listItem = (popupState, item) => {
        const isLink = 'link' in item;
        const rest = omit(item, ['text', 'link', 'icon']);
        const handleClickAndClose = async (e) => {
            if (rest.onClick)
                await Promise.resolve(rest.onClick(e));
            setTimeout(() => popupState.setOpen(false), 100); // Leave the user enough time to read the label
        };
        let result = (React.createElement(ListItem, Object.assign({ key: item.text, button: true }, (!isLink && rest), { onClick: handleClickAndClose }),
            React.createElement(ListItemIcon, { classes: { root: classes.listItemIconRoot } }, item.icon),
            React.createElement(ListItemText, { classes: { primary: classes.listItemTextPrimary } }, item.text)));
        if (isLink)
            result = (React.createElement(NavLink, Object.assign({ to: item.link, className: classes.menuLink, key: item.text }, rest), result));
        return result;
    };
    return (React.createElement(PopupState, { variant: "popover", popupId: "profile-navbar-popover" }, (popupState) => (React.createElement(Fragment, null,
        listItems.length > 0 ? (React.createElement(Button, Object.assign({ className: clsx(classes.avatarButton, { [classes.popupOpen]: popupState.isOpen }) }, bindTrigger(popupState)), avatar)) : (React.createElement(Box, { minWidth: "0px", border: "solid 1px", borderColor: theme.palette.divider, borderRadius: 100, padding: 1, bgcolor: theme.palette.background.default }, avatar)),
        React.createElement(Popover, Object.assign({ elevation: 4 }, bindPopover(popupState), { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, className: classes.popoverWrapper }),
            React.createElement(Grid, { container: true, alignItems: "center", className: classes.header },
                avatar,
                React.createElement("div", { className: classes.avatarNameHeader },
                    React.createElement("div", { className: classes.name }, firstLine),
                    React.createElement("div", { className: classes.email }, secondLine))),
            listItems.map(item => listItem(popupState, item)))))));
}
export default withStyles(styles)(NavbarProfileButton);
//# sourceMappingURL=NavbarProfileButton.js.map